<button class="p8-bdc_add-block__button" [matMenuTriggerFor]="addBlockMenu" mat-mini-fab matTooltip="Ajouter une section">
  <mat-icon>add</mat-icon>
</button>
<mat-menu #addBlockMenu="matMenu">
  <button mat-menu-item (click)="addBlock('text')">
    <mat-icon>text_fields</mat-icon>
    <span>Texte</span>
  </button>
  <button mat-menu-item (click)="addBlock('image')">
    <mat-icon>image</mat-icon>
    <span>Image</span>
  </button>
</mat-menu>
